export class MetadataPackageDto {
    packageName: string;
    packageVersion: string;
    packageLocation: string;
    projectPath: string;

    constructor(packageName: string, packageVersion: string, packageLocation: string, projectPath: string) {
        this.packageName = packageName;
        this.projectPath = projectPath;
        this.packageVersion = packageVersion;
        this.packageLocation = packageLocation;
    }
}
